<script setup lang="ts">
import HpHeading from '@shared/components/hp-heading/hp-heading.vue';
const props = defineProps<{
  campaignsHeadlineText: string;
  campaignsHeadingLevel: string;
}>();
const headlineElement = `h${props.campaignsHeadingLevel}`;
</script>

<template>
  <HpHeading
    class="hp-campaigns__headline"
    :content="campaignsHeadlineText"
    :headingLevel="campaignsHeadingLevel"
  ></HpHeading>
</template>
<style lang="scss">
@import '@workbench/core/dist/scss/_utility.scss';

$moduleName: 'hp-campaigns';

.#{$moduleName} {
  &__headline {
    width: var(--wb-grid-width);
    margin: 0 auto;
    animation-name: moveUp, fadeIn;
    animation-duration: var(--wb-duration-long-1), var(--wb-duration-medium-4);
    animation-timing-function: var(--wb-ease-standard), var(--wb-ease-linear);
    animation-delay: 0, var(--wb-duration-short-2);
    @include wb-heading(
      'l',
      (
        responsive: true,
      )
    );
    color: var(--wb-color-text-main-default);
    padding: var(--wb-spacing-static-medium) 0;
  }
}
</style>
